module.exports = __webpack_public_path__ + "assets/img/25@3x.3a485247.png";